import React from 'react'
import { Button, Typography } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import Dialog from '../../molecules/dialog'
import type { OldNativeVersionDialogProps } from './types'

const OldNativeVersionDialog: React.FC<OldNativeVersionDialogProps> = ({
  nativeVersion,
  showDialog,
  onClose,
  platform,
}) => {
  const { t } = useFavurTranslation()

  if (!nativeVersion) return null

  return (
    <Dialog
      open={showDialog}
      title={t('dialog.oldNativeVersion.title.text', { platform })}
      onClose={onClose}
      actions={
        <Button onClick={onClose} color="primary">
          {t('common.close')}
        </Button>
      }
    >
      <Typography variant="body2">{t('dialog.oldNativeVersion.body.text', { platform })}</Typography>
    </Dialog>
  )
}

export default OldNativeVersionDialog
